var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.33325 14.6665H36.6666V32.9998H7.33325V14.6665Z",
    fill: "#1CD4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 11.0002H22.0001L18.3334 7.3335H7.33342C5.31675 7.3335 3.68508 8.9835 3.68508 11.0002L3.66675 33.0002C3.66675 35.0168 5.31675 36.6668 7.33342 36.6668H36.6668C38.6834 36.6668 40.3334 35.0168 40.3334 33.0002V14.6668C40.3334 12.6502 38.6834 11.0002 36.6668 11.0002ZM36.6668 33.0002H7.33342V14.6668H36.6668V33.0002Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlue);
export default __webpack_public_path__ + "static/media/folder-blue.9fb4fcb85f5358c75a039b28936395bb.svg";
export { ForwardRef as ReactComponent };